import { IsEnum, IsNotEmpty, IsUUID, IsArray, IsOptional, ArrayMinSize } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'
import { CloneDepth } from '../../enums/clone.enum'

/**
 * DTO pour cloner un chapitre
 */
export class CloneChapterDto {
  @ApiProperty({
    description: "IDs des enseignements auxquels rattacher le clone (au moins 1 requis)",
    example: ['a1b2c3d4-e5f6-7890-abcd-ef1234567890', 'b2c3d4e5-f6a7-8901-bcde-f12345678901'],
    type: [String],
  })
  @IsNotEmpty()
  @IsArray()
  @ArrayMinSize(1, { message: 'Au moins un enseignement est requis' })
  @IsUUID('4', { each: true, message: 'Chaque teachingId doit être un UUID valide' })
  teachingIds!: string[]

  @ApiProperty({
    description: 'Profondeur du clonage',
    enum: CloneDepth,
    example: CloneDepth.MEDIUM,
  })
  @IsNotEmpty()
  @IsEnum(CloneDepth)
  depth!: CloneDepth
}

/**
 * DTO pour cloner une leçon
 * Les LessonTeaching sont automatiquement déduits des ChapterTeaching existants
 */
export class CloneLessonDto {
  @ApiProperty({
    type: 'string',
    description: 'ID du chapitre de destination',
    example: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
  })
  @IsNotEmpty()
  @IsUUID('4')
  chapterId!: string

  @ApiProperty({
    description: 'Cloner aussi les ressources (SHALLOW = sans ressources, DEEP = avec ressources)',
    enum: CloneDepth,
    example: CloneDepth.SHALLOW,
  })
  @IsNotEmpty()
  @IsEnum(CloneDepth)
  depth!: CloneDepth
}

/**
 * DTO pour cloner une ressource
 */
export class CloneResourceDto {
  @ApiProperty({
    description: 'IDs des leçons auxquelles rattacher la ressource clonée (optionnel)',
    example: ['a1b2c3d4-e5f6-7890-abcd-ef1234567890'],
    type: [String],
    required: false,
  })
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true, message: 'Chaque lessonId doit être un UUID valide' })
  lessonIds?: string[]

  @ApiProperty({
    description: 'IDs des chapitres auxquels rattacher la ressource clonée (optionnel)',
    example: ['a1b2c3d4-e5f6-7890-abcd-ef1234567890'],
    type: [String],
    required: false,
  })
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true, message: 'Chaque chapterId doit être un UUID valide' })
  chapterIds?: string[]
}
